import baseUrl from "../utils/baseUrl";
import axios from "./api";

const getMechanicByUserId = async (id) => await axios.get(baseUrl + `/mechanics/app-user/${id}`).then((response) => response.data);

const getClientsVehiclesByMechanicId = async (mechanicId, filterText) =>
    await axios.get(baseUrl + `/mechanics/clients/vehicles?mechanicId=${mechanicId}&pageNumber=0&pageSize=20&licensePlate=${filterText}`).then((response) => response.data);

const updateMechanic = async (id, mechanicData) => 
    await axios.put(baseUrl + `/mechanics/${id}`, mechanicData).then((response) => response.data);

export { getMechanicByUserId, getClientsVehiclesByMechanicId, updateMechanic };
